export default __webpack_public_path__ + "media/images/images_v2/onglet-gauche-admin-de1d24a40fa432392cd750ad59b2827f.png";